import { render } from "./FilterMinMax.vue?vue&type=template&id=18b071a4&ts=true"
import script from "./FilterMinMax.vue?vue&type=script&lang=ts"
export * from "./FilterMinMax.vue?vue&type=script&lang=ts"

import "./FilterMinMax.vue?vue&type=style&index=0&id=18b071a4&lang=scss"

import exportComponent from "/home/deploy/wesgroup-production/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__